export default {
  data() {
    return {
      pageSize: 10,
      page: 1,
      total: 0
    }
  },
  methods: {
    pageSizeChanged(pageSize) {
      this.page = 1
      this.pageSize = pageSize
      this.getList()
    }
  }
}
